import { render } from "./ParamCurrencySystemPageList.vue?vue&type=template&id=458de1fe&scoped=true&ts=true"
import script from "./ParamCurrencySystemPageList.vue?vue&type=script&lang=ts"
export * from "./ParamCurrencySystemPageList.vue?vue&type=script&lang=ts"

import "./ParamCurrencySystemPageList.vue?vue&type=style&index=0&id=458de1fe&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458de1fe"]])

export default __exports__